import { FC } from 'react';

import { CircularButton } from 'src/components/CircuralButton';

import styles from './record.module.css';

export const RecordPage: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <div className={styles.buttonWrapper}>
          <CircularButton onClick={() => {}}>RECORD</CircularButton>
        </div>
      </div>
    </div>
  );
};
